import { BingoScheduleItem, PortletSettings } from '../types';

import {
    RESET_BINGO_SCHEDULE, SET_BINGO_SCHEDULE_AND_LOBBY, SET_IS_BINGO_SCHEDULE_LOADED, SET_PORTLET_SETTINGS
} from './actions';

export interface DefaultState {
    isLoaded: boolean;
    bingoSchedule: Array<BingoScheduleItem> | null;
    portletSettings: PortletSettings;
}

export const defaultState: DefaultState = {
    isLoaded: false,
    bingoSchedule: null,
    portletSettings: {
        numberOfColumns: 0,
        numbersOfRoom: 0,
        portletViewMode: ''
    }
};

interface Action {
    payload?: any;
    type: string;
}

type ActionFunction = (state: DefaultState, action: Action) => DefaultState

interface Handler {
    [key: string]: ActionFunction;
}

const handlers: Handler = {
    [SET_BINGO_SCHEDULE_AND_LOBBY]: (state, { payload }) => ({
        ...state,
        bingoSchedule: payload
    }),
    [SET_IS_BINGO_SCHEDULE_LOADED]: (state, { payload }) => ({
        ...state,
        isLoaded: payload
    }),
    [SET_PORTLET_SETTINGS]: (state, { payload }) => ({
        ...state,
        portletSettings: {
            ...state.portletSettings,
            ...payload
        }
    }),
    [RESET_BINGO_SCHEDULE]: () => defaultState
};

export const reducer = (state: DefaultState = defaultState, action: Action): DefaultState => {
    const handler = handlers[action.type];

    return handler ? handler(state, action) : state;
};
